import axios from 'axios';

export async function updatePedidosExcedentes(numeroPedidosExcedentes, cnpj) {
    try{
        const url = `${process.env.VUE_APP_APIURL}/public/updatePedidosExcedentes`
        const body = numeroPedidosExcedentes;
        const atualizaPedidoExcedente = await axios.post(url, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': cnpj,
                body
            }
        });
        return atualizaPedidoExcedente.data.pedidos
    } catch (e) {
        console.error('Erro ao atualizar numero de pedidos excedentes: ', e);
        throw new Error('Falha ao atualizar numero de pedidos excedentes: ', e);
    }
}